/* eslint-disable  */
//@ts-nocheck
'use strict';

import React from 'react';
import _ from 'underscore';

import * as enums from '@playbook-technologies/common-enums';
import helpers from './helpers';
import ajax from './ajax';
import NameAutocomplete from './NameAutocomplete';
import ButtonAddToLibrary from './ButtonAddToLibrary';
import SingleExerciseEdit from './SingleExerciseEdit';
import ModalAddToLibrary from './ModalAddToLibrary';
import ExerciseEditHeader from './ExerciseEditHeader';

class MultipleExerciseEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      minimized: false,
      isLibraryOpen: false,
    };
    this.openLibrary = this.openLibrary.bind(this);
    this.closeLibrary = this.closeLibrary.bind(this);
    this.addFromLibrary = this.addFromLibrary.bind(this);
    this.onToggleMinimize = this.onToggleMinimize.bind(this);
    this.merge = this.merge.bind(this);
    this.descriptionChanged = this.descriptionChanged.bind(this);
    this.durationValueChanged = this.durationValueChanged.bind(this);
    this.durationUnitChanged = this.durationUnitChanged.bind(this);
    this.restChanged = this.restChanged.bind(this);
    this.nameChanged = this.nameChanged.bind(this);
    this.addSingleSubExercise = this.addSingleSubExercise.bind(this);
    this.editSubExercise = this.editSubExercise.bind(this);
    this.moveUpSubExercise = this.moveUpSubExercise.bind(this);
    this.moveDownSubExercise = this.moveDownSubExercise.bind(this);
    this.deleteSubExercise = this.deleteSubExercise.bind(this);
    this.validate = this.validate.bind(this);
  }
  openLibrary() {
    this.setState({
      isLibraryOpen: true,
    });
  }
  closeLibrary() {
    this.setState({
      isLibraryOpen: false,
    });
  }
  addFromLibrary(id) {
    let exercises = this.props.data.exercises;
    ajax
      .getExerciseTemplate(id)
      .then((et) => {
        exercises.push(et.template);
        this.merge({ exercises });
      })
      .catch((e) => {
        console.log('[MultipleExerciseEdit] addFromLibrary() failed.', e);
      });
  }
  onToggleMinimize() {
    if (this.props.minimizeDisabled) return;
    this.merge({ minimized: !this.props.data.minimized });
  }
  merge(newData) {
    let data = _.extend(this.props.data, newData);
    this.props.onChange(this.props.id, data);
  }
  descriptionChanged(ev) {
    this.merge({ description: ev.target.value });
  }
  durationValueChanged(ev) {
    this.merge({ duration: [ev.target.value, this.props.data.duration[1]] });
  }
  durationUnitChanged(ev) {
    this.merge({ duration: [this.props.data.duration[0], ev.target.value] });
  }
  restChanged(rest) {
    this.merge({ rest });
  }
  nameChanged(name) {
    this.merge({ name });
  }
  addSingleSubExercise() {
    let exercises = this.props.data.exercises;
    exercises.push(helpers.generateSingleExercise());
    this.merge({ exercises });
  }
  editSubExercise(id, data) {
    var exercises = this.props.data.exercises;
    exercises[id] = data;
    this.merge({ exercises });
  }
  moveUpSubExercise(id) {
    if (id < 1) return;
    var exercises = this.props.data.exercises;
    var t = exercises[id];
    exercises[id] = exercises[id - 1];
    exercises[id - 1] = t;
    this.merge({ exercises });
  }
  moveDownSubExercise(id) {
    var exercises = this.props.data.exercises;
    if (id === exercises.length - 1) return;
    var t = exercises[id + 1];
    exercises[id + 1] = exercises[id];
    exercises[id] = t;
    this.merge({ exercises });
  }
  deleteSubExercise(id) {
    let exercises = _.without(
      this.props.data.exercises,
      this.props.data.exercises[id],
    );
    this.merge({ exercises });
  }
  validate(attribute) {
    if (
      this.props.tree &&
      this.props.tree[attribute] &&
      this.props.tree[attribute].length > 0
    ) {
      return 'invalid';
    }
    return;
  }
  render() {
    //console.log('[MultipleExerciseEdit] render() called.');
    var exercises = [];
    if (
      this.props.data &&
      this.props.data.exercises &&
      this.props.data.exercises.length
    ) {
      for (var i = 0; i < this.props.data.exercises.length; i++) {
        if (
          this.props.data.exercises[i].type == enums.Exercise.Type.Custom.value
        ) {
          console.error(
            'Trying to render a Custom exercise!',
            this.props.data.exercises[i],
          );
        } else if (
          this.props.data.exercises[i].type == enums.Exercise.Type.Single.value
        ) {
          exercises.push(
            <SingleExerciseEdit
              key={i}
              id={i}
              index={helpers.indexToString(this.props.id, i)}
              data={this.props.data.exercises[i]}
              onDelete={this.deleteSubExercise}
              onMoveUp={this.moveUpSubExercise}
              onMoveDown={this.moveDownSubExercise}
              exerciseLength={this.props.data.exercises.length}
              onChange={this.editSubExercise}
              influencerId={this.props.influencerId}
              libraryEnabled={false}
              statusBar={this.props.statusBar}
              tree={this.props.tree ? this.props.tree.exercises[i] : null}
              setUploadingMedia={this.props.setUploadingMedia}
            />,
          );
        }
      }
    }

    let buttonAddToLibrary = null;
    if (this.props.libraryEnabled) {
      buttonAddToLibrary = (
        <ButtonAddToLibrary
          influencerId={this.props.influencerId}
          template={this.props.data}
          statusBar={this.props.statusBar}
        />
      );
    }

    let message = '';
    if (this.props.tree && this.props.tree.exerciseCount) {
      message = this.props.tree.exerciseCount;
    }

    var content = (
      <div>
        <div className="workoutForm">
          <div className="trinity">
            <div className="first">
              <label>
                Overall title<strong>*</strong>
              </label>
              <NameAutocomplete
                value={this.props.data.name}
                onChange={(e) => {
                  if (e && e.name) {
                    this.nameChanged(e.name);
                  }
                  if (e && e.description) {
                    this.descriptionChanged({
                      target: { value: e.description },
                    });
                  }
                  this.nameChanged(e.name);
                }}
                placeholder="Enter overall title"
                maxLength={60}
              />
            </div>
            <div className="second">
              <label htmlFor="rounds">
                Duration<strong>*</strong>
              </label>
              <input
                className={`duration smaller ${this.validate('duration')}`}
                type="number"
                min={0}
                max={100}
                pattern="\d*"
                value={this.props.data.duration[0]}
                onChange={this.durationValueChanged}
              />
              <select
                className="small"
                value={this.props.data.duration[1]}
                onChange={this.durationUnitChanged}
              >
                <option value="rounds">rounds</option>
                <option value="min">min</option>
                <option value="sec">sec</option>
                <option value="meters">meters</option>
                <option value="calories">calories</option>
              </select>
            </div>
            <div className="third">
              <RestEdit
                onChange={this.restChanged}
                value={this.props.data.rest}
              />
            </div>
          </div>
          <div className="trinity">
            <div className="fourth">
              <label>Overall description</label>
              <textarea
                value={this.props.data.description}
                rows={3}
                cols={80}
                maxLength={2000}
                onChange={this.descriptionChanged}
                placeholder="Enter overall description"
              />
              <br />
              <br />
              <span className="warning">{message}</span>
            </div>
          </div>
        </div>

        {exercises}

        <div className="multipleExerciseToolbox">
          <p>Add Exercise</p>
          <span
            className="actionLink icon-library2"
            onClick={this.openLibrary}
          ></span>
          <span
            className="actionLink icon-single"
            onClick={this.addSingleSubExercise}
          ></span>
        </div>
        {buttonAddToLibrary}
      </div>
    );

    return (
      <div className="multipleExerciseEdit">
        <ExerciseEditHeader
          id={this.props.id}
          data={this.props.data}
          exerciseLength={this.props.exerciseLength}
          index={this.props.index}
          minimizeDisabled={this.props.minimizeDisabled}
          deleteDisabled={this.props.deleteDisabled}
          onToggleMinimize={this.onToggleMinimize}
          onMoveUp={this.props.onMoveUp}
          onMoveDown={this.props.onMoveDown}
          onDelete={this.props.onDelete}
        />
        {this.props.data.minimized ? '' : content}
        <ModalAddToLibrary
          addFromLibrary={this.addFromLibrary}
          influencerId={this.props.influencerId}
          target="multiple"
          isLibraryOpen={this.state.isLibraryOpen}
          closeLibrary={this.closeLibrary}
        />
      </div>
    );
  }
}

class RestEdit extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }
  onChange(ev) {
    let value = parseInt(ev.target.value);
    if (value > 0) this.props.onChange(value);
    else this.props.onChange(null);
  }
  render() {
    let rowContent = <span className="thin">none</span>;
    if (this.props.value > 0) {
      rowContent = (
        <span className="thin">
          <strong className="thin">{this.props.value}</strong> seconds
        </span>
      );
    }
    return (
      <div>
        <label>Rest between rounds: {rowContent}</label>
        <input
          className="rest"
          type="range"
          min={0}
          max={300}
          step={5}
          onChange={this.onChange}
          value={this.props.value ? this.props.value : 0}
        />
      </div>
    );
  }
}

export default MultipleExerciseEdit;
